import makeActionCreator from 'src/lib/makeActionCreator';

export const SET_ADVANCED_SEARCH = 'SET_ADVANCED_SEARCH';
export const RESET_ADVANCED_SEARCH = 'RESET_ADVANCED_SEARCH';

export const setAdvancedSearch = makeActionCreator(SET_ADVANCED_SEARCH);
export const resetAdvancedSearch = makeActionCreator(RESET_ADVANCED_SEARCH);
